import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="form-error-focus"
// Automatically focuses and scrolls to the first error on any form
export default class extends Controller {
  static targets = ["errorContainer"];
  static values = {
    errorSelector: {
      type: String,
      default: '[data-auto-save-target="errorContainer"]',
    },
    questionSelector: {
      type: String,
      default: '[data-survey-response-target="question"]',
    },
    inputSelector: { type: String, default: "input, select, textarea" },
    highlightDuration: { type: Number, default: 2000 },
  };
  static classes = ["highlight"];

  connect() {
    // Check for errors after the page loads
    this.checkForErrors();
  }

  checkForErrors() {
    // Look for error containers with actual error messages
    const errorContainers = this.element.querySelectorAll(
      this.errorSelectorValue,
    );

    for (const container of errorContainers) {
      if (container.textContent.trim()) {
        // Found an error, focus and scroll to the first input in the question/field
        this.focusAndScrollToError(container);
        break;
      }
    }
  }

  focusAndScrollToError(errorContainer) {
    // Find the container that contains this error
    const fieldContainer =
      errorContainer.closest(this.questionSelectorValue) ||
      errorContainer.parentElement;

    if (!fieldContainer) return;

    // Find the first input element in the field
    const firstInput = fieldContainer.querySelector(this.inputSelectorValue);

    if (firstInput) {
      // Scroll to the field container with some offset
      fieldContainer.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });

      // Focus the input after a short delay to ensure scrolling is complete
      setTimeout(() => {
        firstInput.focus();

        // Add a visual highlight to the field container
        this.addHighlight(fieldContainer);

        // Remove the highlight after the specified duration
        setTimeout(() => {
          this.removeHighlight(fieldContainer);
        }, this.highlightDurationValue);
      }, 100);
    }
  }

  addHighlight(element) {
    element.classList.add(...this.highlightClassList);
  }

  removeHighlight(element) {
    element.classList.remove(...this.highlightClassList);
  }

  get highlightClassList() {
    return this.hasHighlightClass
      ? this.highlightClasses
      : ["ring-2", "ring-error", "ring-offset-2", "rounded-lg"];
  }
}

